import { useTranslation } from 'react-i18next';
import Modal from '../../../core/components/Modal';
import PersonalSmartInboxSection from './PersonalSmartInboxSection';

interface ManagePersonalSmartInboxModalProps {
    integration: any;
    isAdminConsentGranted: boolean;
    isAdminConsentUpToDate: boolean;
    onClose: () => void;
    onRefresh: () => Promise<any>;
}

const ManagePersonalSmartInboxModal = ({
    integration,
    isAdminConsentGranted,
    isAdminConsentUpToDate,
    onClose,
    onRefresh,
}: ManagePersonalSmartInboxModalProps) => {
    const { t } = useTranslation('users');

    return (
        <Modal
            visible={true}
            onClose={onClose}
            title={t('overview.moreMenu.manageSmartInbox')}
            className="lg:min-w-[55rem]"
        >
            <PersonalSmartInboxSection
                integration={integration}
                isAdminConsentGranted={isAdminConsentGranted}
                isAdminConsentUpToDate={isAdminConsentUpToDate}
                onRefresh={onRefresh}
                onClose={onClose}
            />
        </Modal>
    );
};

export default ManagePersonalSmartInboxModal;
